import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Container, Dropdown, Menu, Segment } from 'semantic-ui-react';
import { MainIcon } from '../../components';
// import { DropdownItem } from './components';
import './index.css';

class Nav extends React.Component {
  render() {
    const { activeItem, isLoggedIn } = this.props;
    const log = {
      name: 'login',
      url: './login',
    };
    if (isLoggedIn) {
      log.name = 'logout';
      log.url = './logout';
    }
    return (
      <Segment basic inverted color="black" style={{ padding: 0, margin: 0 }}>
        <Container>
          <Menu className="mainNav" inverted pointing secondary>
            <Menu.Item
              name="home"
              active={activeItem === 'icon'}
              as={Link}
              to="/"
              className="mainIcon"
            >
              <MainIcon />
            </Menu.Item>
            <Menu.Item
              name="home"
              active={activeItem === 'home'}
              as={Link}
              to="/"
            />
            <Dropdown
              className={
                activeItem === 'bittrex'
                  ? 'active secondaryMenu'
                  : 'secondaryMenu'
              }
              item
              text="Markets"
              name="markets"
              closeOnChange
            >
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/bittrex">
                  Bittrex
                </Dropdown.Item>
                <Dropdown.Item disabled={true} as={Link} to="/binance">
                  Binance
                </Dropdown.Item>
                <Dropdown.Item disabled={true} as={Link} to="/poloniex">
                  Poloniex
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Menu.Item
              name="roadmap"
              active={activeItem === 'roadmap'}
              as={Link}
              to="/roadmap"
            />
            <Menu.Menu position="right">
              <Menu.Item name={log.name} as={Link} to={log.url} />
              {!isLoggedIn && (
                <Menu.Item name="Sign Up" as={Link} to="/signup" />
              )}
            </Menu.Menu>
          </Menu>
        </Container>
      </Segment>
    );
  }
}

Nav.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.jsx